import {z} from 'zod';

export const GROUP_PIPELINE_VIEW_KEY = 'internal.groupPipeline';

export const LIST_COLUMNS = [
  {key: 'phase', label: 'Phase'},
  {key: 'currentStep', label: 'Current step'},
  {key: 'status', label: 'Status'},
  {key: 'members', label: 'Members'},
  {key: 'effective', label: 'Effective'},
] as const;

export type ListColumnKey = (typeof LIST_COLUMNS)[number]['key'];

export const DEFAULT_LIST_COLUMN_KEYS: ListColumnKey[] = LIST_COLUMNS.map((c) => c.key);

// Step keys; a tenant without a step simply has no column for it.
export const DEFAULT_BOARD_COLUMN_KEYS = [
  'collecting_docs',
  'awaiting_census',
  'census_build_out',
  'census_review',
  'implementation_call',
  'dry_run',
  'go_live_run',
];

export const groupPipelineViewConfigSchema = z.object({
  listColumns: z.array(
    z.enum(LIST_COLUMNS.map((c) => c.key) as [ListColumnKey, ...ListColumnKey[]]),
  ),
  boardColumns: z.array(z.string().min(1)),
  hideEmptyColumns: z.boolean().default(false),
});

export type GroupPipelineViewConfig = z.infer<typeof groupPipelineViewConfigSchema>;

export const DEFAULT_GROUP_PIPELINE_VIEW: GroupPipelineViewConfig = {
  listColumns: DEFAULT_LIST_COLUMN_KEYS,
  boardColumns: DEFAULT_BOARD_COLUMN_KEYS,
  hideEmptyColumns: false,
};
